<template>
	<div class="template-integral">
		<van-nav-bar class="custom-nav-bar" :title="$t('withdraw.page_title')">
			<template #left>
				<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
					<div class="nav-bar__back">
						<span class="tn-icon-left-arrow"></span>
					</div>
				</div>
			</template>
		</van-nav-bar>
		<div class="page-content">
			<div class="account-card">
				<div class="account-header">
					<div class="account-title">
						{{ $t('assets.account_balance') }}
					</div>
				</div>
				<div class="account-balance">
					<div class="balance-amount">
						€ {{ displayBalance }}
					</div>
				</div>
			</div>

			<div class="amount-section">
				<div class="section-title">
					<div class="title-text">{{ $t('withdraw.amount_title') }}</div>
				</div>
				<div class="amount-input">
					<div class="tn-top">
						<input v-model.trim="withdraw_money" type="number" :placeholder="$t('withdraw.amount_placeholder')" />
					</div>
				</div>
			</div>

			<div class="form-section">
				<div class="section-title">
					<div class="title-text">
						{{ $t('withdraw.info_title') }}
					</div>
				</div>
				<div class="form">
					<div class="input-item">
						<div class="input-label">{{ $t('common.name') }}</div>
						<div class="input">
							<input v-model.trim="bankUserName" type="text" :placeholder="$t('common.name')" />
						</div>
					</div>
					<div class="input-item">
						<div class="input-label">{{ $t('withdraw.iban') }}</div>
						<div class="input">
							<input v-model.trim="bankAccount" type="text" :placeholder="$t('withdraw.iban')" />
						</div>
					</div>
					<div class="input-item">
						<div class="input-label">{{ $t('withdraw.bank_name') }}</div>
						<div class="input">
							<input v-model.trim="bankName" type="text" :placeholder="$t('withdraw.bank_name')" />
						</div>
					</div>
				</div>
			</div>

			<div class="rule-section">
				<div class="rule-item">
					<span class="rule-dot">•</span>
					<span class="rule-text">{{ $t('withdraw.min_amount_label') }}{{ displayMinWithdraw }}</span>
				</div>
				<div class="rule-item">
					<span class="rule-dot">•</span>
					<span class="rule-text">{{ $t('withdraw.business_hours_label') }}{{ businessHoursText }}</span>
				</div>
				<div class="rule-item">
					<span class="rule-dot">•</span>
					<span class="rule-text">{{ $t('withdraw.arrival_time_tip') }}</span>
				</div>
				<div class="rule-item">
					<span class="rule-dot">•</span>
					<span class="rule-text">{{ $t('withdraw.bank_info_tip') }}</span>
				</div>
			</div>

			<div class="btn-section">
				<div class="btn" @click="doWithdraw">{{ $t('withdraw.page_title') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				withdraw_money: "",
				userInfo: {},
				withdrawRole: {},
				bankInfo: {},
				bankUserName: "",
				bankAccount: "",
				bankName: ""
			};
		},
		computed: {
			baseInfo() {
				return this.$store.getters.getBaseInfo || {};
			},
			baseMinWithdraw() {
				return this.parseAmount(this.baseInfo.withraw_min || this.baseInfo.withdraw_min || 0);
			},
			businessHoursText() {
				return this.baseInfo.withraw_business_hours || this.baseInfo.withdraw_business_hours || '09:00-18:00';
			},
			displayBalance() {
				return this.formatAmount(this.userInfo.money);
			},
			displayMinWithdraw() {
				return this.formatAmount(this.getCurrentLevelWithdrawMin());
			}
		},
		methods: {
			parseAmount(value) {
				const amount = parseFloat(String(value || '0').replace(/,/g, ''));
				return Number.isFinite(amount) ? amount : 0;
			},
			formatAmount(value) {
				return this.parseAmount(value).toFixed(2);
			},
			getCurrentLevel() {
				if (!this.userInfo.all_levels || !this.userInfo.vip) return null;
				return this.userInfo.all_levels.find(level => level.name === this.userInfo.vip);
			},
			getCurrentLevelWithdrawMax() {
				const level = this.getCurrentLevel();
				if (level && level.withdraw_max_amount !== undefined) {
					return this.parseAmount(level.withdraw_max_amount);
				}
				return this.parseAmount(this.withdrawRole.max);
			},
			getCurrentLevelWithdrawMin() {
				if (this.baseMinWithdraw > 0) {
					return this.baseMinWithdraw;
				}
				return this.parseAmount(this.withdrawRole.min);
			},
			getCurrentLevelMinCompletedOrders() {
				const level = this.getCurrentLevel();
				return level ? level.min_completed_orders : 0;
			},
			isWithinBusinessHours() {
				const businessHours = this.businessHoursText;
				const match = /^(\d{2}):(\d{2})-(\d{2}):(\d{2})$/.exec(businessHours);
				if (!match) {
					return false;
				}
				const startMinutes = Number(match[1]) * 60 + Number(match[2]);
				const endMinutes = Number(match[3]) * 60 + Number(match[4]);
				const now = new Date();
				const currentMinutes = now.getHours() * 60 + now.getMinutes();
				if (startMinutes <= endMinutes) {
					return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
				}
				return currentMinutes >= startMinutes || currentMinutes <= endMinutes;
			},
			getUserBankInfo() {
				this.$http({
					method: 'get',
					url: 'user_get_bank'
				}).then(res => {
					if (res.code === 200) {
						this.bankInfo = res.data.info || {};
						this.bankUserName = this.bankInfo.username || this.bankInfo.name || this.bankUserName;
						this.bankAccount = this.bankInfo.account || this.bankInfo.walletAddress || this.bankInfo.bankid || this.bankAccount;
						this.bankName = this.bankInfo.bankName || this.bankInfo.bankinfo || this.bankName;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
			back() {
				return window.history.back();
			},
			getBaseInfo() {
				this.$http({
					method: 'get',
					url: 'base_info'
				}).then(res => {
					if (res.code === 200) {
						this.$store.commit('setBaseInfoValue', res.data || {});
					}
				});
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						if (!this.bankUserName) {
							this.bankUserName = res.data.name || '';
						}
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
			getUserWithdrawRole() {
				this.$http({
					method: 'get',
					url: 'user_get_withdraw_role'
				}).then(res => {
					if (res.code === 200) {
						this.withdrawRole = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
			doWithdraw() {
				if (!String(this.withdraw_money).trim()) {
					this.$toast(this.$t('withdraw.enter_amount'));
					return false;
				}

				const amount = this.parseAmount(this.withdraw_money);
				if (amount <= 0) {
					this.$toast(this.$t('withdraw.enter_valid_amount'));
					return false;
				}
				if (!this.bankUserName) {
					this.$toast(this.$t('withdraw.enter_name'));
					return false;
				}
				if (!this.bankAccount) {
					this.$toast(this.$t('withdraw.enter_account'));
					return false;
				}
				if (!this.bankName) {
					this.$toast(this.$t('withdraw.enter_bank_name'));
					return false;
				}

				const minAmount = this.getCurrentLevelWithdrawMin();
				const maxAmount = this.getCurrentLevelWithdrawMax();
				const balance = this.parseAmount(this.userInfo.money);
				const todayCompleted = this.userInfo.daily_order_limit ? this.userInfo.daily_order_limit.today_completed :
					0;
				const minCompletedOrders = this.getCurrentLevelMinCompletedOrders();

				if (amount < minAmount) {
					this.$toast(this.$t('withdraw.min_amount_error_prefix') + this.formatAmount(minAmount));
					return false;
				}

				if (maxAmount > 0 && amount > maxAmount) {
					this.$toast(this.$t('withdraw.max_amount_error_prefix') + this.formatAmount(maxAmount));
					return false;
				}

				if (amount > balance) {
					this.$toast(this.$t('withdraw.insufficient_balance'));
					return false;
				}

				if (todayCompleted < minCompletedOrders) {
					this.$toast(this.$t('withdraw.min_completed_orders_prefix') + minCompletedOrders + this.$t(
						'withdraw.min_completed_orders_suffix'));
					return false;
				}

				if (!this.isWithinBusinessHours()) {
					this.$toast(this.$t('withdraw.business_hours_error_prefix') + this.businessHoursText);
					return false;
				}

				this.$http({
					method: 'post',
					data: {
						money: amount,
						username: this.bankUserName,
						bankid: this.bankAccount,
						bankinfo: this.bankName
					},
					url: 'user_set_withdraw'
				}).then(res => {
					if (res.code === 200) {
						this.$toast(res.msg);
						this.getUserInfo();
						this.getUserWithdrawRole();
						this.getUserBankInfo();
						this.withdraw_money = '';
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				if (!Object.keys(this.baseInfo).length) {
					this.getBaseInfo();
				}
				this.getUserInfo();
				this.getUserWithdrawRole();
			}
		},
		mounted() {
			this.getUserBankInfo();
		}
	};
</script>

<style lang='less' scoped>
	/* 页面容器 */
	.template-integral {
		background-color: #f5f5f5;
		min-height: 100vh
	}

	/* 导航栏返回按钮 */
	.custom-nav-bar {
		height: 45px;
		position: fixed;
		z-index: 999;
		display: block;
		position: relative;
		line-height: normal;
	}

	::v-deep .van-nav-bar__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 0;
		height: 45px;
		padding-top: 0px;
		background-color: rgb(255, 255, 255);
		z-index: 29090;
		box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, .05);
		position: fixed;
		width: 100%;
		top: 0;
	}

	::v-deep .van-nav-bar__left {
		padding: 0;
	}

	::v-deep .van-nav-bar__title {
		color: #000 !important;
		font-size: 18px;
		font-weight: 700;
		top: 0px;
		height: 45px;
		line-height: 45px;
		width: calc(100% - 100px);
		position: absolute;
		text-align: center;
		left: 0;
		right: 0;
		bottom: 0;
		cursor: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px;
	}

	/* 页面内容 */
	.page-content {
		padding: 20px 10px;
	}

	/* 冻结资金提示 */
	.frozen-tip {
		margin-top: 6px;
		font-size: 12px;
		color: hsla(0, 0%, 100%, .75)
	}

	/* 账户信息卡片 */
	.account-card {
		background: linear-gradient(135deg, #d4aff9, #1f77d5);
		border-radius: 10px;
		padding: 15px;
		margin-bottom: 12px;
		color: #fff;
		box-shadow: 0 2px 10px rgba(31, 119, 213, .3)
	}

	.account-card .account-header {
		margin-bottom: 10px
	}

	.account-card .account-header .account-title {
		font-size: 14px;
		font-weight: 600
	}

	.account-card .account-balance .balance-amount {
		font-size: 24px;
		font-weight: 700
	}

	/* 金额输入区域 */
	.amount-section {
		background: #fff;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 12px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08)
	}

	.amount-section .section-title {
		margin-bottom: 10px
	}

	.amount-section .section-title .title-text {
		font-size: 14px;
		font-weight: 600;
		color: #333
	}

	.amount-section .amount-input {
		background: #f8f9fa;
		border-radius: 6px;
		padding: 0 10px
	}

	.amount-section .amount-input .tn-top {
		width: 100%;
		height: 41px;
		font-size: 14px;
		color: #333;
	}

	.amount-section .amount-input input {
		outline: none;
		border: none;
		padding: 0;
		margin: 0;
		text-decoration: inherit;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		position: relative;
		width: 100%;
		height: 100%;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		flex-direction: column;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		position: relative;
		display: block;
		height: 100%;
		background: none;
		color: inherit;
		opacity: 1;
		font: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		text-align: inherit;
		text-indent: inherit;
		text-transform: inherit;
		text-shadow: inherit;
	}

	/* 表单区域 */
	.form-section {
		background: #fff;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 12px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08)
	}

	.form-section .section-title {
		margin-bottom: 10px
	}

	.form-section .section-title .title-text {
		font-size: 14px;
		font-weight: 600;
		color: #333
	}

	.form-section .form .input-item {
		display: flex;
		flex-direction: column;
		margin-bottom: 12px
	}

	.form-section .form .input-item .input-label {
		font-size: 12px;
		color: #666;
		margin-bottom: 6px
	}

	.form-section .form .input-item .input {
		width: 100%;
		height: 41px;
		background: #f8f9fa;
		border-radius: 6px;
		padding: 0 10px;
		font-size: 12px;
		color: #333
	}

	.form-section .form .input-item .input input {
		outline: none;
		border: none;
		padding: 0;
		margin: 0;
		text-decoration: inherit;
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		position: relative;
		width: 100%;
		height: 100%;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		flex-direction: column;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		position: relative;
		display: block;
		height: 100%;
		background: none;
		color: inherit;
		opacity: 1;
		font: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		text-align: inherit;
		text-indent: inherit;
		text-transform: inherit;
		text-shadow: inherit;
	}

	.form-section .form .input-item input .input-placeholder {
		font-size: 12px;
		color: #aaa
	}

	/* 规则区域 */
	.rule-section {
		background: #fff;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 16px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08)
	}

	.rule-section .rule-item {
		display: flex;
		align-items: flex-start;
		margin-bottom: 6px
	}

	.rule-section .rule-item .rule-dot {
		font-size: 12px;
		color: #1f77d5;
		margin-right: 6px;
		margin-top: 2px
	}

	.rule-section .rule-item .rule-text {
		font-size: 11px;
		color: #666;
		flex: 1
	}

	/* 按钮区域 */
	.btn-section {
		margin-bottom: 20px
	}

	.btn {
		font-weight: 700;
		background-color: #3d7eff !important;
		color: #fff;
		box-shadow: 6px 6px 8px #d8e5ff;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		line-height: 1;
		text-align: center;
		text-decoration: none;
		overflow: visible;
		-webkit-transform: translate(0px, 0px);
		transform: translate(0px, 0px);
		border-radius: 6px;
		margin: 0;
		padding: 20px 0px;
		font-size: 14px;
		height: 33px;
		width: 100%;
	}

	.btn:after {
		content: " ";
		width: 200%;
		height: 200%;
		position: absolute;
		top: 0;
		left: 0;
		border: 1px solid rgba(0, 0, 0, .2);
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		box-sizing: border-box;
		border-radius: 10px;
	}

	.btn::after {
		border: none;
	}

	/* 输入框样式 */
	.uni-input-wrapper {
		color: #333 !important
	}
</style>
